{
	"translateAcquirerTansactionType": {
		"credit": "Crédito",
		"debit": "Débito"
	}
}
